"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreHelperMessages = void 0;
var CoreHelperMessages;
(function (CoreHelperMessages) {
    CoreHelperMessages["CORE_PROMISE_TIMEOUT_REACHED"] = "Promise timeout reached";
    CoreHelperMessages["CORE_UUID_INVALID"] = "Hash length must be equal to 32";
    CoreHelperMessages["CORE_COOKIES_MAX_BYTES"] = "Be careful, you reach the cookies limit size!";
})(CoreHelperMessages || (exports.CoreHelperMessages = CoreHelperMessages = {}));
//# sourceMappingURL=messages.js.map